import React, {useEffect, useState} from "react";
import {faArrowCircleRight} from "@fortawesome/free-solid-svg-icons";


import './AppointmentView.css';
import {ToolTip} from "../../common/tool-tip/ToolTip";
import {loadUserProfile} from "../../../services/AccountService";
import {formatDateAsString} from "../../../util/StringUtil";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {retrieveIndicator} from "../../../services/IndicatorService";
import {retrieveVisitWithPeople} from "../../../services/VisitService";
import {viewProblem, viewProblemOverview} from "../../../services/ProblemService";
import {viewPDSA} from "../../../services/PDSAService";

export const AppointmentView = ({context, setContext, navigateTo, showToaster, setSpinnerText, toolTipsEnabled}) => {

    const [userProfile, setUserProfile] = useState(null);
    const [userAppointmentList, setUserAppointmentList] = useState([]);

    const loadProfile = async () => {
        setSpinnerText("Loading appointments");
        const [data, error] = await loadUserProfile(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                const userProfileRetrieved = data.userProfileVO;
                if (userProfileRetrieved) {
                    setUserProfile(userProfileRetrieved);
                    const userAppointmentListRetrieved = userProfileRetrieved.appointmentsForUser;
                    if (userAppointmentListRetrieved) {
                        setUserAppointmentList(userAppointmentListRetrieved);
                    }
                }
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    useEffect(() => {
        const fetchData = async () => {
            await loadProfile();
        }
        fetchData();
    }, []);


    const fetchIndicator = async (indicatorExternalReference) => {
        let savedIndicator = null;
        const [data, error] = await retrieveIndicator(context.username, indicatorExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedIndicator = data.indicatorVOToView;
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedIndicator;
    }

    const fetchVisit = async (visitExternalReference) => {
        let savedVisit = null;
        const [data, error] = await retrieveVisitWithPeople(context.username, visitExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedVisit = data.visitVOToView;
            } else {
                showToaster(error);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedVisit;
    }

    const fetchProblem = async (problemExternalReference) => {
        let savedProblem = null;
        const [data, error] = await viewProblem(context.username, problemExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedProblem = data.problemVOToView;
            } else {
                showToaster(error);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedProblem;
    }

    const fetchProblemOverview = async (problemExternalReference) => {
        let savedProblemOverview = null;
        const [data, error] = await viewProblemOverview(context.username, problemExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedProblemOverview = data.problemOverview;
            } else {
                showToaster(error);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedProblemOverview;
    }

    const fetchPDSA = async (PDSAExternalReference) => {
        let savedPDSA = null;
        const [data, error] = await viewPDSA(context.username, PDSAExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedPDSA = data.pdsaVOToView;
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedPDSA;
    }

    const handlePDSAClick = async (PDSAExternalReference, problemExtRef) => {
        setSpinnerText("Retrieving PDSA");
        let savedPDSA = await fetchPDSA(PDSAExternalReference);
        let savedProblemOverview = await fetchProblemOverview(problemExtRef);
        let savedChangeIdeaTitle = null;
        let savedChangeIdeaExtRef = null;
        if (savedProblemOverview) {
            if (savedProblemOverview.routeCauseList) {
                savedProblemOverview.routeCauseList.map((rootCause) => {
                    if (rootCause.changeIdeaList) {
                        rootCause.changeIdeaList.map((changeIdea) => {
                            if (changeIdea.pdsalist) {
                                changeIdea.pdsalist.map((PDSA) => {
                                    if (PDSA.externalReference === PDSAExternalReference) {
                                        savedChangeIdeaTitle = changeIdea.name;
                                        savedChangeIdeaExtRef = changeIdea.externalReference;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }

        if (savedPDSA) {
            const mappedProcessMeasureList = savedPDSA.processMeasures.map((processMeasure) => {
                return {...processMeasure}
            });

            setContext((prevState) => ({
                ...prevState,
                viewMode: true,
                editMode: true,
                breadcrumbs: [],
                changeIdeaScreen: {
                    externalReference: savedChangeIdeaExtRef,
                    title: savedChangeIdeaTitle,
                },
                copyOfTopicAreaScreen: null,
                copyOfProblemScreen: null,
                copyOfRootCauseScreen: null,
                copyOfChangeIdeaScreen: null,
                problemScreen: {
                    externalReference: problemExtRef,
                },
                problemToBeViewedExternalReference: problemExtRef,
                PDSAScreen: {
                    externalReference: savedPDSA.externalReference,
                    name: savedPDSA.name,
                    processMeasureList: mappedProcessMeasureList,
                    who: savedPDSA.who,
                    what: savedPDSA.what,
                    where: savedPDSA.where,
                    testStartDate: savedPDSA.testStartDate,
                    testReviewDate: savedPDSA.testReviewDate,
                    scale: savedPDSA.scale,
                    observation: savedPDSA.observations,
                    balancingMeasureOne: savedPDSA.balanceMeasureA,
                    balancingMeasureTwo: savedPDSA.balanceMeasureB,
                    balancingMeasureThree: savedPDSA.balanceMeasureC,
                    analysis: savedPDSA.analysis,
                    status: {value: savedPDSA.status, label: savedPDSA.status,},
                    statusMovement: savedPDSA.statusMovement,
                    rationale: savedPDSA.rationale,
                    nextVisitDate: savedPDSA.dateOfNextVisit,
                },
            }));
            navigateTo("PDSACycle");
        }
        setSpinnerText(null);
    }

    const handleProblemClick = async (externalReference) => {
        setSpinnerText("Retrieving Problem");
        let savedVisit = null;
        let savedIndicator = null;
        const savedProblem = await fetchProblem(externalReference);

        if (savedProblem) {
            savedVisit = await fetchVisit(savedProblem.visitExternalRef);
        }

        if (savedVisit) {
            savedIndicator = await fetchIndicator(savedVisit.indicatorExternalReference);
        }

        if (savedIndicator) {
            setContext((prevState) => ({
                ...prevState,
                viewMode: true,
                breadcrumbs: [],
                changeIdeaScreen: null,
                copyOfTopicAreaScreen: null,
                copyOfProblemScreen: null,
                copyOfRootCauseScreen: null,
                copyOfChangeIdeaScreen: null,
                problemScreen: {
                    externalReference: savedProblem.externalReference,
                    title: savedProblem.name,
                    description: savedProblem.description,
                    nextVisitDate: savedVisit.dateOfNextVisit,
                    frequency: {
                        label: savedProblem.reviewFrequency,
                        value: savedProblem.reviewFrequency
                    },
                    baselines: savedProblem.outcomeMeasureBaselines,
                    toImprove: savedProblem.aimStatementVO.toImprove,
                    from: savedProblem.aimStatementVO.from,
                    to: savedProblem.aimStatementVO.to,
                    byDate: savedProblem.aimStatementVO.by,
                },
                problemToBeViewedExternalReference: savedProblem.externalReference,
                rootCauseScreen: null,
                topicAreaScreen: {
                    visitExternalReference: savedProblem.visitExternalRef,
                    indicator: {
                        outcomeMeasure: savedIndicator.outcomeMeasure,
                        numerator: savedIndicator.numerator,
                        denominator: savedIndicator.denominator,
                    },
                    topicArea: {
                        externalReference: savedProblem.topicAreaExternalRef,
                        topicArea: savedProblem.topicAreaName,
                    },
                    grant: {externalReference: savedProblem.grantExternalRef, name: null},
                },
                facilityScreen: {
                    levelOfSupport: {label: savedProblem.levelOfSupport},
                    locationExternalReference: savedProblem.locationExternalRef,
                },
            }));
            navigateTo("problemOne");
        }
        setSpinnerText(null);
    }

    const handleAppointmentClick = async (appointment) => {
        if (appointment.pdsaExternalReference) {
            await handlePDSAClick(appointment.pdsaExternalReference, appointment.problemExternalReference);
        } else if (appointment.problemExternalReference) {
            await handleProblemClick(appointment.problemExternalReference);
        }
    }

    const appointmentList = userAppointmentList.map((appointmentVO, index) => {
        let location = null;
        const {facility, subDistrict, district, province, country} = appointmentVO.appointmentLocation;
        if (facility) {
            location = facility;
        } else if (subDistrict) {
            location = subDistrict;
        } else if (district) {
            location = district;
        } else if (province) {
            location = province;
        } else if (country) {
            location = country;
        }

        return (
            <div className="appointment" key={index}>
                <p>{`${formatDateAsString(appointmentVO.dateOfAppointment)}  -  ${location} - ${appointmentVO.problemName}`}</p>
                <FontAwesomeIcon icon={faArrowCircleRight}
                                 aria-label={"appointment-button"}
                                 className={"appointment-icon"}
                                 onClick={() => {
                                     handleAppointmentClick(appointmentVO);
                                 }}/>
            </div>
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-right-container-n">
                    <div className="notification-container">
                        <div className={"label-div-tooltip-nn"}>
                            <label className={"label"}>Appointments:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"appointments123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Appointments:"}/>}
                        </div>
                        <div className={"text-box-a"}>
                            {userProfile && userAppointmentList ?
                                <ul className={"comment-container-a"}>
                                    {appointmentList}
                                </ul> :
                                <p className={"no-comments-message"}>No appointments yet</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
